<div class="container-flex px-5">
    <!--Primary toolbar-->
    <div class="row">
        <div class="col-10 offset-1">
            <ul class="nav nav-tabs mt-3" *ngIf="legacyPermissions && legacyCount > 0">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': tab === 0}" (click)="changeTab(0)"
                       cvLocalizedText langSection="Subscriptions_Management" langKey="New">New</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active': tab === 1}" (click)="changeTab(1)"
                       cvLocalizedText langSection="Subscriptions_Management" langKey="Legacy">Legacy</a>
                </li>
            </ul>
            <div class="d-flex align-items-center tab-content pt-3 mx-0 mb-3">
                <div ngbDropdown *ngIf="tab === 0" class="d-inline-block" style="width: 170.6px">
                    <button type="button" class="btn btn-primary" id="subscriptionDropdown" [disabled]="loading" ngbDropdownToggle>
                        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                        <span style="padding-left: 3.41px; padding-right: 4px;" cvLocalizedText langSection="Subscriptions_Management"
                              langKey="New_Subscription">New Subscription</span>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="subscriptionDropdown">
                        <button type="button" ngbDropdownItem (click)="openNewDashboardSubscription()"
                                cvLocalizedText langSection="Subscriptions_Management" langKey="Dashboard">
                            Dashboard
                        </button>
                        <button type="button" ngbDropdownItem (click)="openNewWidget()"
                                cvLocalizedText langSection="Subscriptions_Management" langKey="Module">
                            Widget
                        </button>
                    </div>
                </div>

                <div class="flex-grow-1"></div>
                <button type="button" class="btn btn-text btn-icon fill-cerulean mr-3" [disabled]="loading" (click)="exportBulk()">
                    <svg><use href="../App_Themes/clearview-default/icons/utility/export.svg#export"></use></svg>
                    <span cvLocalizedText langSection="Subscriptions_Management" langKey="Export">Export</span>
                </button>

                <div class="search-box live-search" style="width:235px">
                    <input type="search" class="form-control form-control-gray" cvLocalizedPlaceholder langSection="Common" langKey="Search"
                           [(ngModel)]="filterValue" (ngModelChange)="applyFilterAgGrid()" />
                    <span class="clear-input" [hidden]="filterValue.length == 0" (click)="filterValue = ''; applyFilterAgGrid()"></span>
                </div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-10 offset-1">
            <div class="d-flex flex-column h-100 position-relative">
                <cv-loader *ngIf="loading" [overlay]="true" [size]="'large'"></cv-loader>
                <div class="d-flex align-items-center pl-3 border-top border-right border-left"
                     style="height:38.525px; background-color:#F5F7F7; border-color:#BDC3C7 !important">
                    <span class="font-size-11 color-whaleTail" style="margin-right:12px">
                        {{selectedRows}} <span cvLocalizedText langSection="Custom_Data_Import" langKey="Selected">selected</span>
                    </span>
                    <button type="button" class="btn btn-text-gray btn-icon" [disabled]="selectedRows != 1" (click)="edit()">
                        <svg><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
                        <span class="font-size-11" cvLocalizedText langSection="Common" langKey="Edit">Edit</span>
                    </button>
                    <button type="button" class="btn btn-text-gray btn-icon pl-0" [disabled]="selectedRows <= 0"
                            (click)="delete()">
                        <svg><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
                        <span class="font-size-11" cvLocalizedText langSection="Common" langKey="Delete">Delete</span>
                    </button>
                    <button type="button" class="btn btn-text-gray btn-icon pl-0" [disabled]="selectedRows != 1" (click)="exportIndividual()">
                        <svg><use href="../App_Themes/clearview-default/icons/utility/export.svg#export"></use></svg>
                        <span class="font-size-11" cvLocalizedText langSection="Subscriptions_Management" langKey="Export">Export</span>
                    </button>
                </div>

                <ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions"
                                 [ngStyle]="{'height': (legacyPermissions && legacyCount > 0) ? 'calc(100vh - 243px - 42px)' : 'calc(100vh - 243px + 13px)' }"></ag-grid-angular>
            </div>
        </div>
    </div>
</div>
<cv-create-report-subscription *ngIf="showNewWidget" [editMode]="editMode" [editObject]="(editMode)? selected : null" (onSave)="onSaved()"
                               (onClose)="onClosed()"></cv-create-report-subscription>
<cv-subscription-management-edit *ngIf="showLegacyEdit" [subscription]="legacySubscription" (onSaved)="onSaved()" (onClosed)="onClosed()"></cv-subscription-management-edit>
<cv-subscription-scheduler [isDashboardModal]="false" *ngIf="showScheduler" [reportType]="reportType" [subscriptionId]="subscriptionId" [subscriptionTitle]="title"
                           [relatedId]="relatedId" [relatedKey]="relatedKey" (saved)="onSaved()" (closed)="onClosed()"></cv-subscription-scheduler>

<ng-container *ngIf="showNewDashboard">
    <div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:1550"></div>
    <div class="bg-white rounded shadow d-flex flex-column mx-auto py-3 position-fixed"
         style="width:300px; z-index:1551; top:50%; left:50%; transform:translate(-50%,-50%); padding:0px 32px;">
        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="showNewDashboard = false">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
        </button>
        <div class="font-size-20 pb-3 border-bottom mb-4" cvLocalizedText langSection="Subscriptions_Management" langKey="New_Subscription">
            New Subscription
        </div>
        <div style="position: relative;">
            <cv-loader *ngIf="loadingDashboards" [overlay]="true" [size]="'small'"></cv-loader>
            <div class="font-size-12 mb-1" cvLocalizedText langSection="Subscriptions_Management" langKey="Dashboard">Dashboard</div>

            <select class="form-control" [(ngModel)]="selectedDashboard">
                <option value="null" disabled hidden cvLocalizedText langSection="Subscriptions_Management"
                        langKey="None_Selected">
                    None selected
                </option>
                <option *ngFor="let dashboard of dashboards" [ngValue]="dashboard">{{dashboard.DashboardName}}</option>
            </select>
        </div>
        <div class="d-flex justify-content-end pt-3 border-top mt-4">
            <button type="button" class="btn btn-text mr-2" (click)="showNewDashboard = false"
                    cvLocalizedText langSection="Common" langKey="Cancel_Button">
                Cancel
            </button>
            <button type="button" class="btn btn-primary" (click)="newDashboardOnNext()"
                    [disabled]="!selectedDashboard" cvLocalizedText langSection="Common" langKey="Next_Button">
                Next
            </button>
        </div>
    </div>
</ng-container>

<!-- Unconverted SFTP Management HTML -- Since this was commented out in the AngularJS code I've decided to preserve it here in case it
        is needed in the future; the tab and ag-grid parts were not preserved as those are pretty simple to add - Richard Curylo

    Ryan Richins Comment:
    This has been set to the "SFTP Management" tab merely for convenience. It will eventually be deleted and the actual SFTP Management content added, but for now, SFTP is not on the table
                and I need a place to put this. Delete this once no longer needed (also delete case 2 of the SaveEdit function in SubscriptionManagementEdit.js).-->
<!--Subscription Display-->
<!--<div class="w-100 position-relative" data-ng-if="ctrl.sf.tab == 2">-->
<!--Selection action bar-->
<!--<div class="SelectionActionBar w-100 position-absolute ml-0" style="top:-50px" data-ng-class="(ctrl.sf.selectedSubscriptions.length > 0) ? 'SelectionActionShow' : 'SelectionActionHide'">
        <span class="d-inline-block float-left">
            <span class="mr-3 clickable" ng-click="ctrl.onSelectionCancel()" runat="server" Lang_Section="Common" Lang_Key="Cancel_Button">Cancel</span>
            <span class="mr-3 clickable" ng-if="ctrl.sf.selectedSubscriptions.length == 1" ng-click="ctrl.toggleEditPopup()" runat="server" Lang_Section="Common" Lang_Key="Edit">Edit</span>
            <span class="mr-3 clickable" data-ng-click="ctrl.export(true)" runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Export">Export</span>
            <span class="clickable" style="margin-right:0px" ng-click="ctrl.onDeleteSelection()" runat="server" Lang_Section="Common" Lang_Key="Delete">Delete</span>
        </span>
        <span class="float-right" data-ng-if="ctrl.sf.selectedSubscriptions.length == 1">1 <span runat="server" Lang_Section="Common" Lang_Key="Item_Selected">Item Selected</span></span>
        <span class="float-right" data-ng-if="ctrl.sf.selectedSubscriptions.length > 1">
            {{ctrl.sf.selectedSubscriptions.length}} <span runat="server" Lang_Section="Common" Lang_Key="Items_Selected">Items Selected</span>
        </span>
        <div class="SelectionArrow"></div>
    </div>

    <div class="d-flex border-bottom font-size-16 lato-bold" style="line-height:18px">
        <div class="d-flex align-items-center pr-4 pl-3" style="width:calc(2.5% + 40px)">
            <input type="checkbox" class="hidden" />
        </div>

        <div class="pb-2 clickable" style="min-width:20%; max-width:20%" data-ng-click="ctrl.changeOrder('Name')">
            <span runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Name">Name</span>
            <div class="sgSortArrows">
                <div class="sgUpArrow" data-ng-class="{'sgSelectUpArrow': ctrl.sf.orderBy === 'Name', 'sgHideUpArrow': ctrl.sf.orderBy === '-Name'}"></div>
                <div class="sgDownArrow" data-ng-class="{'sgSelectDownArrow': ctrl.sf.orderBy === '-Name', 'sgHideDownArrow': ctrl.sf.orderBy === 'Name'}"></div>
            </div>
        </div>

        <div class="pb-2 clickable" style="width:8%" data-ng-click="ctrl.changeOrder('Type')">
            <span runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Type">Type</span>
            <div class="sgSortArrows">
                <div class="sgUpArrow" data-ng-class="{'sgSelectUpArrow': ctrl.sf.orderBy === 'Type', 'sgHideUpArrow': ctrl.sf.orderBy === '-Type'}"></div>
                <div class="sgDownArrow" data-ng-class="{'sgSelectDownArrow': ctrl.sf.orderBy === '-Type', 'sgHideDownArrow': ctrl.sf.orderBy === 'Type'}"></div>
            </div>
        </div>

        <div class="overflow-hidden pb-2 clickable" style="width:20%" data-ng-click="ctrl.changeOrder('Creator')">
            <span runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Creator">Creator</span>
            <div class="sgSortArrows">
                <div class="sgUpArrow" data-ng-class="{'sgSelectUpArrow': ctrl.sf.orderBy === 'Creator', 'sgHideUpArrow': ctrl.sf.orderBy === '-Creator'}"></div>
                <div class="sgDownArrow" data-ng-class="{'sgSelectDownArrow': ctrl.sf.orderBy === '-Creator', 'sgHideDownArrow': ctrl.sf.orderBy === 'Creator'}"></div>
            </div>
        </div>

        <div class="pb-2 clickable" style="width:10%" data-ng-click="ctrl.changeOrder('Frequency')">
            <span runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Frequency">Frequency</span>
            <div class="sgSortArrows">
                <div class="sgUpArrow" data-ng-class="{'sgSelectUpArrow': ctrl.sf.orderBy === 'Frequency', 'sgHideUpArrow': ctrl.sf.orderBy === '-Frequency'}"></div>
                <div class="sgDownArrow" data-ng-class="{'sgSelectDownArrow': ctrl.sf.orderBy === '-Frequency', 'sgHideDownArrow': ctrl.sf.orderBy === 'Frequency'}"></div>
            </div>
        </div>

        <div class="pb-2 clickable" style="width:39.5%" data-ng-click="ctrl.changeOrder('Recipients')">
            <span runat="server" Lang_Section="Subscriptions_Management" Lang_Key="Recipients">Recipients</span>
            <div class="sgSortArrows">
                <div class="sgUpArrow" data-ng-class="{'sgSelectUpArrow': ctrl.sf.orderBy === 'Recipients', 'sgHideUpArrow': ctrl.sf.orderBy === '-Recipients'}"></div>
                <div class="sgDownArrow" data-ng-class="{'sgSelectDownArrow': ctrl.sf.orderBy === '-Recipients', 'sgHideDownArrow': ctrl.sf.orderBy === 'Recipients'}"></div>
            </div>
        </div>
    </div>
    <div class="overflow-auto" style="height:calc(100vh - 219px)">
        <div class="SubscriptionTableRow d-flex clickable" style="height:40px" data-ng-repeat="sub in ctrl.sf.workingSubscriptions | orderBy: ctrl.sf.orderBy"
             data-ng-class="{ SubscriptionTableSelected: sub.IsChecked }"
             data-ng-click="sub.IsChecked = !sub.IsChecked; ctrl.onCheckboxChange(sub.BaseIndex)">
            <div class="d-flex align-items-center pr-4 pl-3" style="width:calc(2.5% + 40px)">
                <input type="checkbox" class="sgCustomCheckbox" data-ng-model="sub.IsChecked" data-ng-change="ctrl.onCheckboxChange(sub.BaseIndex)" data-ng-click="$event.stopPropagation()" />
            </div>
            <div class="d-flex align-items-center pr-2" style="min-width:20%; max-width:20%" title="{{sub.Name}}"><span class="text-truncate">{{sub.Name}}</span></div>
            <div class="d-flex align-items-center pr-2" style="width:8%" title="{{sub.TypeText}}"><span class="text-truncate">{{sub.TypeText}}</span></div>
            <div class="d-flex align-items-center pr-2" style="width:20%" title="{{sub.Creator}}"><span class="text-truncate">{{sub.Creator}}</span></div>
            <div class="d-flex align-items-center pr-2" style="width:10%" title="{{sub.FrequencyText}}"><span class="text-truncate">{{sub.FrequencyText}}</span></div>
            <div class="d-flex align-items-center pr-2" style="width:39.5%" title="{{sub.FormattedRecipients}}"><span class="text-truncate">{{sub.FormattedRecipients}}</span></div>
        </div>
    </div>
</div>-->
